// --> wrapper types
export const WRAPPER_HORIZONTAL = "WRAPPER_HORIZONTAL"
export const WRAPPER_VERTICAL_CENTER = "WRAPPER_VERTICAL_CENTER"

// --> store types
export const ADD_EXPENSE_FORM = "ADD_EXPENSE_FORM"
export const ADD_INCOME_FORM = "ADD_INCOME_FORM"
export const CLOSE_ALL_SELECT = "CLOSE_ALL_SELECT"
export const EXPENSE_TOGGLE = "EXPENSE_TOGGLE"
export const INCOME_TOGGLE = "INCOME_TOGGLE"
export const SIGNIN = "SIGNIN"
export const USER_LOADED = "USER_LOADED"
export const SET_LOGGED = "SET_LOGGED"
export const DATA_LOADED = "DATA_LOADED"
export const NEW_PERSON = "NEW_PERSON"
export const NEW_CATEGORY = "NEW_CATEGORY"
export const NEW_EXPENSE = "NEW_EXPENSE"
export const NEW_INCOME = "NEW_INCOME"
export const NEW_SOURCE = "NEW_SOURCE"
export const CLEAR_EXPENSE = "CLEAR_EXPENSE"
export const CLEAR_INCOME = "CLEAR_INCOME"
export const BOARD_CHANGE_EXPENSE = "BOARD_CHANGE_EXPENSE"
export const BOARD_CHANGE_FUNDS = "BOARD_CHANGE_FUNDS"
export const DELETE_FUND = "DELETE_FUND"
export const DELETE_EXPENSE = "DELETE_EXPENSE"

// --> notification types
export const ERROR = "ERROR"
export const SUCCESSFUL = "SUCCESSFUL"
export const WARNING = "WARNING"
export const LOADING = "LOADING"

// --> filter types
export const PRICE = "PRICE"
export const EXPENSE = "EXPENSE"
export const FUND = "FUND"
export const DATE = "DATE"

export const CURRENCY_LOAD = "CURRENCY_LOAD"

